const legOffsets = {
  nordic: {
    14: 5.5,
    18: 3,
    23: 0,
    29: -2,
  },
  "nordic-seamless": {
    14: 5.5,
    18: 3,
    23: 0,
  },
  "nordic-line": {
    14: 5.5,
    18: 3,
    23: 0,
  },
  "nordic-line-niche": {
    14: 1.4,
  },
  lean: {
    14: 6.5,
    18: 3,
    23: 0,
  },
  continental: {
    7: 2,
    9: 1,
    10: 0,
    14: -1.9,
    18: -3,
    23: -5.55,
  },
  "aqtive-ii": {
    7: 2,
    9: 1,
    10: 0,
    14: -1.9,
    18: -3,
    23: -5.55,
  },
  "aqtive-2-3": {
    7: 2,
    9: 1,
    10: 0,
    14: -1.9,
    18: -3,
    23: -5.55,
  },
  dream: {
    7: 2,
    9: 1,
    10: 0,
    14: -1.9,
    18: -3,
    23: -5.55,
  },
  "aqtive-i": {
    10: 0,
    14: -2.4,
  },
};

const bedOffsets = {
  nordic: {
    27: 0,
    30: -0.6,
  },
  "nordic-seamless": {
    27: 0,
    30: -0.6,
  },
  continental: {
    42: 0.7,
    45: 0,
    49: -0.6,
    54: 0,
    66: -2.6,
  },
};

const specialOffsets = {
  sub_mat: {
    nordic: 1.6,
    "nordic-seamless": 1.6,
    continental: -3.4,
  },
  bottom: {
    nordic: -3.2,
    "nordic-seamless": -3.2,
    "nordic-line": -3.4,
    continental: 2,
    "aqtive-ii": 2.8,
    dream: 2.8,
    "aqtive-i": 2.5,
    lean: -4.5,
  },
  tray: {
    nordic: 4,
    "nordic-seamless": 4,
  },
};

export { legOffsets, bedOffsets, specialOffsets };
